module.exports = __webpack_public_path__ + "static/img/wget-2.bb243439.png";